(() => {
  const easterSunday = (year) => {
    const a = year % 19;
    const b = Math.floor(year / 100);
    const c = year % 100;
    const d = Math.floor(b / 4);
    const e = b % 4;
    const f = Math.floor((b + 8) / 25);
    const g = Math.floor((b - f + 1) / 3);
    const h = (19 * a + b - d - g + 15) % 30;
    const i = Math.floor(c / 4);
    const k = c % 4;
    const l = (32 + 2 * e + 2 * i - h - k) % 7;
    const m = Math.floor((a + 11 * h + 22 * l) / 451);
    const month = Math.floor((h + l - 7 * m + 114) / 31) - 1;
    const day = ((h + l - 7 * m + 114) % 31) + 1;
    return new Date(year, month, day);
  };

  const key = (date) => `${date.getFullYear()}-${String(date.getMonth()+1).padStart(2,'0')}-${String(date.getDate()).padStart(2,'0')}`;
  const addDays = (date, days) => { const d = new Date(date); d.setDate(d.getDate() + days); return d; };

  const holidays = (year) => {
    const easter = easterSunday(year);
    return new Set([
      `${year}-01-01`, `${year}-05-01`, `${year}-05-08`, `${year}-07-14`, `${year}-08-15`, `${year}-11-01`, `${year}-11-11`, `${year}-12-25`,
      key(addDays(easter, 1)), key(addDays(easter, 39)), key(addDays(easter, 50))
    ]);
  };

  const compute = (start, businessDays) => {
    const date = new Date(start.getFullYear(), start.getMonth(), start.getDate());
    let remaining = Math.max(0, Number(businessDays) || 14);
    while (remaining > 0) {
      date.setDate(date.getDate() + 1);
      const day = date.getDay();
      if (day !== 0 && day !== 6 && !holidays(date.getFullYear()).has(key(date))) remaining -= 1;
    }
    return date;
  };

  const render = () => {
    document.querySelectorAll('[data-lmdl-dispatch-date]').forEach((el) => {
      if (el.dataset.ready === 'true') return;
      const target = compute(new Date(), el.dataset.businessDays);
      const formatted = new Intl.DateTimeFormat('fr-FR', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' }).format(target);
      const prefix = el.dataset.prefix || 'Départ estimé de l’atelier :';
      el.textContent = `${prefix} ${formatted}`;
      el.dataset.ready = 'true';
    });
  };

  document.addEventListener('DOMContentLoaded', render);
  document.addEventListener('shopify:section:load', render);
  render();
})();
